import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { SystemLogModel, SystemLogOperationType } from "../types/SystemLog";
import { removeEmptyKeysFromFilters } from "src/utils/object";

export const RQ_SYSTEM_LOGS_LIST_KEY = "SYSTEM_LOGS_LIST_KEY";

export type SystemLogListResponse = PagedResponse<SystemLogModel[]>;

export type SystemLogListFilters = {
    companyUserId?: string;
    operationType?: SystemLogOperationType;
    entityType?: string;
    entityId?: string;
    dateFrom?: string;
    dateTo?: string;
};

export const useSystemLogsList = (
    page: number,
    rowsPerPage: number,
    searchFilters?: SystemLogListFilters
) => {
    const filters = searchFilters ? removeEmptyKeysFromFilters(searchFilters) : {};

    return useQuery({
        queryKey: [
            RQ_SYSTEM_LOGS_LIST_KEY,
            page,
            rowsPerPage,
            filters?.companyUserId ? `${filters.companyUserId}` : "",
            filters?.operationType ? `${filters.operationType}` : "",
            filters?.entityType ? `${filters.entityType}` : "",
            filters?.entityId ? `${filters.entityId}` : "",
            filters?.dateFrom ? `${filters.dateFrom}` : "",
            filters?.dateTo ? `${filters.dateTo}` : "",
        ],
        queryFn: async (): Promise<SystemLogListResponse | null> => {
            const res = await axiosCompanyInstance.get(`system-log`, {
                params: { ...filters, page: page + 1, perPage: rowsPerPage },
            });

            return res?.data || null;
        },
    });
};
